import { Box, Typography, useTheme } from "@mui/material";

interface IFeatureTag {
  text: string;
}

const FeatureTag = ({ text }: IFeatureTag) => {
  const theme = useTheme();
  return (
    <Box bgcolor={"dsAmber.v100"} padding={theme.spacing(0.25, 1)} borderRadius={10}>
      <Typography variant="textBase600" color="text.primary">
        {text.toUpperCase()}
      </Typography>
    </Box>
  );
};

export default FeatureTag;
